<template>
  <div class="admin-layout">
    <div class="admin-left" :class="menuIsCollapse ? 'collapse' : ''">
      <div class="admin-title"><span>工业产品管理后台</span></div>
      <div class="admin-menu">
        <el-scrollbar>
          <el-menu :default-active="menuActive" :collapse="menuIsCollapse" @select="handleSelect"
            :collapse-transition="false">
            <template v-for="menu in menuList">
              <template v-if="menu.children && menu.children.length > 0">
                <el-submenu :index="menu.index" :key="menu.index">
                  <template slot="title">
                    <Icon :name="menu.icon" />
                    <span slot="title">{{ menu.name }}</span>
                  </template>
                  <el-menu-item v-for="item in menu.children" :index="item.index" :key="item.index">{{ item.name
                  }}</el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="menu.index" :key="menu.index">
                  <Icon :name="menu.icon" />
                  <span slot="title">{{ menu.name }}</span>
                </el-menu-item>
              </template>
            </template>
            <el-menu-item v-if="role_id === '2'" index="userRole">
              <Icon name="menu15" />
              <span slot="title">用户管理</span>
            </el-menu-item>
            <el-menu-item v-if="role_id === '2'" index="AppManage">
              <Icon name="menu16" />
              <span slot="title">应用管理</span>
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </div>
      <div class="menu-btn" @click="handleMenuBtn">
        <Icon :name="menuIsCollapse ? 'menuRight' : 'menuLeft'" />
      </div>
    </div>
    <div class="admin-main">
      <router-view />
    </div>
  </div>
</template>

<script>
import apis from '@/api'
import { ADMIN_MENU_TREE } from '@/utils/authority.util.js'

export default {
  name: 'AdminLayout',
  provide() {
    return {
      unreadWebsocketData: this.unreadWebsocketData
    }
  },
  data() {
    return {
      menuIsCollapse: false,
      menuActive: '',
      menuList: [],
      userName: '',
      activeName: 'first',
      showDot: false,
      unreadWebsocketData: {
        unreadTotal: 0
      },
      unreadList: [
        // { alarm_id: 1, alarm_name: '111', alarm_detail: '11', start_time: '2025-07-01' }
      ],
      unreadCount: 0,
      unreadLoading: false,
      unreadNoMore: false,
      ModifyPasswordTitle: '修改密码',
      ModifyPasswordVisible: false,
      ModifyPasswordData: {
        oldPassword: '',
        newPassword: '',
        confirm_password: ''
      },
      ModifyPasswordRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.ModifyPasswordData.newPassword) {
                callback(new Error('两次输入的密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      columns: [
        { label: '消息类型', prop: 'alarm_name' },
        { label: '消息内容', prop: 'alarm_detail' }
      ]
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        if (this.$route.meta.title) {
          this.menuActive = this.$route.meta.title
        } else {
          this.menuActive = this.$route.name
        }
      }
    }
  },
  created() {
    this.menuActive = this.$route.name
    this.menuList = ADMIN_MENU_TREE
    this.userName = localStorage.getItem('username')
    this.registerTime = localStorage.getItem('registerTime')
    this.role_id = localStorage.getItem('roleId')
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.connection) {
      this.connection.off('unread', this.handleData)
      this.connection.close()
    }
  },
  methods: {
    handleSelect(index) {
      if (['dashboardMain', 'dashboardSub'].includes(index)) {
        window.open(`/${index}`, '_blank')
      } else {
        if (this.$route.name !== index) {
          this.$router.push({ name: index })
        }
      }
    },
    handleMenuBtn() {
      this.menuIsCollapse = !this.menuIsCollapse
    },
    loginOut() {
      const request = {
        ...apis.USER_LOGINOUT
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.$router.push({ path: '/login' })
              localStorage.clear()
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    handleModifyPassword() {
      this.ModifyPasswordVisible = true
    },
    ModifyPasswordSubmit() {
      this.$refs.ModifyPasswordForm.validate((valid) => {
        if (valid) {
          this.ModifyPasswordVisible = false
          const request = {
            ...apis.USER_MODIFYPASSWORD,
            params: {
              ...this.ModifyPasswordData
            }
          }
          this.$request(request)
            .asyncThen(
              (resp) => {
                if (resp.rst === 200) {
                  this.$router.push({ path: '/login' })
                  localStorage.clear()
                }
              },
              (err) => {
                console.error(err)
              }
            )
            .asyncErrorCatch((err) => {
              console.error('额外错误处理:', err)
            })
        } else {
          return false
        }
      })
    },
    closeModifyPasswordDialog() {
      this.ModifyPasswordData.oldPassword = ''
      this.ModifyPasswordData.newPassword = ''
      this.ModifyPasswordData.confirm_password = ''
      this.$nextTick(() => {
        this.$refs.ModifyPasswordForm.clearValidate()
      })
    },
    handleData(data) {
      if (data) {
        this.unreadWebsocketData.unreadTotal = data.total
        if (this.unreadWebsocketData.unreadTotal > 0) {
          this.showDot = true
        } else {
          this.showDot = false
        }
      }
    },
    loadUnread() {
      if (this.unreadLoading) return
      this.unreadLoading = true
      this.unreadCount += 1
      this.queryAlarmLogData(1, this.unreadCount).then((data) => {
        if (data.alarms.length === 0) {
          this.unreadNoMore = true
        }
        this.unreadList = [...this.unreadList, ...data.alarms]
        this.unreadLoading = false
      })
    },
    clearData() {
      this.unreadCount = 0
      this.unreadList = []
    },
    queryAlarmLogData(type, currentPage) {
      const request = {
        ...apis.QUERY_ALARM_LOG_LIST,
        params: {
          type: type,
          currentPage: currentPage
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                resolve(resp.data)
              }
            },
            (err) => {
              console.error(err)
              reject(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
            reject(err)
          })
      })
    },
    readedClick(id) {
      if (this.unreadList.length === 0) {
        this.$message({
          message: '暂无未读消息',
          type: 'warning'
        })
      } else {
        console.log('已读')
        let ids = []
        if (id) {
          ids.push(id)
        }
        const request = {
          ...apis.READ_ALARM_LOG,
          params: {
            id: ids
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.unreadCount = 0
                this.unreadList = []
                this.loadUnread()
                const query = {
                  method: 'notice/unread'
                }
                this.connection.send(query)
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      }
    }
  }
}
</script>

<style scoped>
.message-badge-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .count-badge {
    /* 调整 99+ 提示样式 */
    margin-right: 10px;
    line-height: 10px;
  }

  ::v-deep .el-badge__content.is-fixed.is-dot {
    right: 15px;
    top: 10px;
  }
}

.unread-message {
  background: #ffffff;
  width: 100%;

  .unread-message-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;

    .header-title {
      color: #476653;
      font-size: 16px;
      font-weight: 500;
      font-family: "SourceHanSansCN";
      text-align: left;
      line-height: 14px;
    }

    .readed {
      /* position: absolute;
      top: 15px;
      right: 40px; */
      color: #476653;
      font-size: 16px;
      cursor: pointer;
      z-index: 9;

      &:hover {
        color: #32B768;
      }
    }
  }

  .infinite-list {
    height: 356px;
    overflow-y: auto;

    .infinite-msg {
      text-align: center;
    }

    .item {
      padding: 16px 24px;
      min-height: 111px;

      .tittle {
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        h2 {
          padding-bottom: 8px;
          color: #000000;

          i {
            margin-right: 10px;
            color: #1CC6A1;
            font-weight: bold;
          }
        }

        span {
          color: #476653;
        }
      }

      p {
        padding-left: 32px;
        color: #476653;
        font-size: 16px;
      }
    }
  }
}

.user-info-panel {
  .top-info {
    display: flex;
    align-items: center;

    .user-main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 16px;
    }

    .modify-link {
      cursor: pointer;
      color: #32b768;
      font-size: 16px;
      font-weight: 400;
      font-family: "SourceHanSansCN";
      text-align: center;
    }
  }

  .account-info {
    margin-top: 15px;
  }
}

.el-menu-item {
  font-size: 16px
}

.el-menu-item .svg-icon {
  width: 20px;
  height: 20px;
}

.admin-title {
  padding: 20px;
  height: 86px;
  width: 100%;
  text-align: center;
  align-items: center;
  font-family: Arimo;
  font-weight: 400;
  font-style: Regular;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0px;

}

::v-deep .el-menu-item.is-active {
  border-radius: 10px;
}

::v-deep .el-menu-item.is-active .svg-icon {
  color: #155DFC !important;
}

/* 如果你的 Icon 组件使用的是 font-class 形式 (例如 <i class="el-icon el-icon-user"></i>)，请使用这个选择器 */
::v-deep .el-menu-item.is-active .el-icon {
  color: #155DFC !important;
}
</style>
